<template>
  <v-sheet class="fill-height" tile color="white">
    <v-container fluid>
      <v-row>
        <v-col v-for="store in visibleStores" cols="12" lg="4" xs="12" sm="6" md="6" :key="store.id">
          <StoreTile mode="edit" :store="store"></StoreTile>
        </v-col>
        <v-col align="right" cols="12" class="add-item-btn">
          <v-btn x-large rounded color="primary" :to="{'name':PAGE_IDS.STORE_ADD}" primary>
            <v-icon class="mr-1">add</v-icon>
            Add Store
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="visibleStores.length == 0">
        <div class="no-data">
          <div>
            <v-img width="156" class="mb-6" src="/static/no_data_stores.svg"/>
            <span>
                    No stores found
                </span>
          </div>
        </div>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";
  import StoreTile from "./StoreTile";

  export default {
    name: "StoresList",
    components: {StoreTile},
    computed: {
      ...mapGetters(['allStores', 'getCurrentBrand']),
      visibleStores() {
        return this.allStores.filter((item) => item.brand_id == this.getCurrentBrand)
      }
    },
    mounted: function () {
      this.$store.dispatch('reloadBrandsStores')
    }
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/Stores/StoresList.vue